<template>
  <div>
    <div>
      <div class="btn2">
        <button @click="min_boxEvt(1)" :class="{ active: activeTab === '1' }">基本信息</button>
        <button @click="min_boxEvt(2)" :class="{ active: activeTab === '2' }">素材信息</button>
        <button @click="min_boxEvt(3)" :class="{ active: activeTab === '3' }">销售信息</button>
      </div>
    </div>


    <el-table v-if="activeTab =='1' " :data="data" :cell-style="rowStyle" :summary-method="getSummaries"
      style="width: 100%; overflow: none;font-size:12px" class="copy" ref="sortTable" @sort-change="sortChangeEvt" show-summary>
      <el-table-column prop="cover" label="图例" width="180" align="center" sortable="custom"    fixed>
        <template slot-scope="props">
          <el-image :src="props.row.cover" class="img_box"> </el-image>
        </template>
      </el-table-column>

      <el-table-column prop="id" label="ID" width="120" align="left" sortable="custom"   label-class-name="source_ID" >
        <template slot-scope="props">
          <span style="width:60px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.source_id }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="Vertices" width="160" label="上传者" align="left" sortable="custom">
        <template slot-scope="props">
          <p>
            <span>{{ props.row.model_info.Vertices }}</span>
          </p>
        </template>
      </el-table-column>

      <el-table-column prop="" label="上传日期" width="120" align="left" sortable="custom"  >
      </el-table-column>
      <el-table-column prop="" label="最后查看日期" width="140" align="left" sortable="custom"    >
      </el-table-column>
      <el-table-column prop="" label="最后下载日期" width="180" align="left" sortable="custom"   >
      </el-table-column>
      <el-table-column prop="" label="查看次数" width="100" align="left" sortable="custom"    >
      </el-table-column>
      <el-table-column prop="" label="下载次数" width="100" align="left" sortable="custom"    >
      </el-table-column>
      <el-table-column prop="" label="收藏次数" width="150" align="left" sortable="custom"   >
      </el-table-column>
      <el-table-column prop="" label="封面尺寸" width="120" align="left" sortable="custom" >
      </el-table-column>
      <el-table-column prop="" label="文件大小" width="120" align="left" sortable="custom"    >
      </el-table-column>

      <el-table-column prop="amount3" width="120" label="评分" align="center">
        <template slot-scope="props">
          <div>
            <span> {{ props.row.score }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="review_num" label="保密" align="left" sortable="custom">
        <template slot-scope="props">
          <span :style="{ color: props.row.download_num == 0 ? '#d1d1d1' : '#333' }">
            {{ props.row.model_info.encrypt_state === 0 ? '未审核' : props.row.model_info.encrypt_state === 1 ? '保密' : '公开'
            }}</span>
        </template>
      </el-table-column>
     
    </el-table>
    <el-table v-if="activeTab == '2'" :data="data" :cell-style="rowStyle" :summary-method="getSummaries" show-summary
      style="width: 100%; overflow: none;font-size:12px" class="copy" ref="sortTable" @sort-change="sortChangeEvt">

      <el-table-column prop="cover" label="图例" width="180" align="center" sortable="custom"    fixed >
        <template slot-scope="props">
          <el-image :src="props.row.cover" class="img_box"> </el-image>
        </template>
      </el-table-column>

      <el-table-column prop="id" label="ID" width="150" align="left" sortable="custom"   label-class-name="source_ID" >
        <template slot-scope="props">
          <span style="width:60px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.source_id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="SavedAsVersion" width="160" label="文件版本" align="left" sortable="custom">
        <template slot-scope="props">
          <p>
            <span>{{ props.row.model_info.SavedAsVersion }}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="ZipSize" width="200" label="压缩包大小" align="left" sortable="custom">
        <template slot-scope="props">
          <p>
            <span>{{ formatBytes(props.row.model_info.ZipSize) }}</span>
          </p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="MaxSize" width="180" label="Max大小" align="center" sortable="custom">
        <template slot-scope="props">
          <p>
            <span>{{ formatBytes(props.row.model_info.MaxSize) }}</span>
          </p>
        </template>
      </el-table-column> -->

      <el-table-column prop="Maps" width="100" label="贴图数量" align="center" sortable="custom">
        <template slot-scope="props">
          <span>{{ props.row.model_info.Maps }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Objects" width="100"  label="物体数量" align="center" sortable="custom">
        <template slot-scope="props">
          <span>{{ props.row.model_info.Objects }}</span>
        </template>

      </el-table-column>
      <el-table-column prop="Faces" width="100" label="素材面数" align="center" sortable="custom">
        <template slot-scope="props">
          <span>{{ props.row.model_info.Faces }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Vertices" width="90" label="顶点数" align="center" sortable="custom">
        <template slot-scope="props">
          <span>{{ props.row.model_info.Vertices }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Shapes" width="80" label="样条线" align="center" sortable="custom">
        <template slot-scope="props">
          <span :style="{ color: props.row.model_info.Shapes == 0? '#d1d1d1' : '#333' }">
            {{ props.row.model_info.Shapes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Lights" width="80" label="灯光" align="center" sortable="custom">
        <template slot-scope="props">
          <span :style="{ color: props.row.Lights.Lights == 0? '#d1d1d1' : '#333' }">
            {{ props.row.model_info.Lights }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="last_download" width="150" label="相机" align="left" sortable="custom">
        <template slot-scope="props">
          <span :style="{ color: props.row.Lights.Cameras == 0? '#d1d1d1' : '#333' }">
            {{ props.row.model_info.Cameras }}</span>
        </template>
      </el-table-column>


      <el-table-column prop="last_download" width="150" label="渲染器" align="center" sortable="custom">
        <template slot-scope="props">
          <span>{{ props.row.model_info.RendererName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="last_download"  label="森林" align="left" sortable="custom">
      </el-table-column>
    </el-table>
    <el-table v-if="activeTab == '3'" :data="data" :cell-style="rowStyle" :summary-method="getSummaries" show-summary
      style="width: 100%; overflow: none;font-size:12px" class="copy" ref="sortTable" @sort-change="sortChangeEvt">
      <el-table-column prop="cover" label="图例" width="300" align="left" sortable="custom">
        <template slot-scope="props">
          <el-image :src="props.row.cover" class="img_box"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="price" width="80" label="单价" align="left" sortable="custom">
        <template slot-scope="props">
          <p>
            <span>{{ props.row.price }}</span>
          </p>
        </template>
      </el-table-column>

      <el-table-column prop="size" width="120" label="销售数量" align="center" sortable="custom">
      </el-table-column>
      <el-table-column prop=""  label="销售金额" align="left" sortable="custom">
      </el-table-column>
    </el-table>

    <div style="height: 160px"></div>
  </div>
</template>



<script>
  export default {
    props: ["data", "num"],
    data() {
      return {
        activeTab: '1',

      };
    },
    created() {


    },
    method(){
    },
    methods: {
      formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      },
      min_boxEvt(e){
        this.activeTab = e.toString(); // 更新 activeTab 的值为当前点击按钮的值
        this.$refs.sortTable.clearSort();
      },
      clearSort() {
        // 调用 sortTable 的 clearSort 方法
        if (this.$refs.sortTable) {
          this.$refs.sortTable.clearSort && this.$refs.sortTable.clearSort();
        }
       },
      limitEvt() { },
      handleCurrentChange() { },
      //
      rowStyle({ row, column, rowIndex, columnIndex }) {
        //this.levelData='至尊会员'
      },

      //显示修改输入框
      editShowEvt(e) {
        this.editShowInp = e.id;
        this.$nextTick((_) => {
          this.$refs.editInput.$refs.input.focus();
        });
      },

      openDialog(resData) {},
      //列表排序
      //列表排序
      sortChangeEvt(row) {
          // 过滤条件：无排序方向 或 无排序字段 时不触发事件
          if (!row.order || !row.prop) return;
        // 严格匹配排序方向，避免异常值
        let order;
        if (row.order === 'ascending') {
          order = 'asc';
        } else if (row.order === 'descending') {
          order = 'desc';
        } else {
          return; // 非预期方向直接返回
        }
        this.$emit('Min_BOX', {
          orWhere: row.prop,
          order
        });
      },
      editInpBlurEvt() {
        this.editShowInp = null;
      },
      getSummaries(param) {
        const { columns, data } = param;

        const sums = [];
        columns.forEach((column, index) => {
          for (let key in this.$props.num) {
            if (column.property == key) {
              sums[index] = this.$props.num[key];
            }
          }
          // if (index === 1) {
          //   sums[index] = 'ID总和';
          //   return;
          // }else if (index === 2) {
          //   sums[index] = '去重总和';
          //   return;
          // }else if (index === 5) {
          //   sums[index] = '公开总和';
          //   return;
          // }

        });
        return sums;
      },
    },
  };
</script>

<style lang="less" scoped>
  @import url("../style/space.less");
  @import url("../style/modelList.less");

  .search-box {
    width: calc(100% - 190px);
    min-width: 1200px;
    height: 90px;
    background: #fff;
    padding: 10px;
    position: fixed;
    top: 60px;
    z-index: 1123;
    visibility: inherit;
    /*box-shadow: 0px 10px 10px 1px rgba(226, 226, 226, 0.4);*/
    transition: all 0.8s ease 0.4s;
  }

  .search-box1 {
    height: 0;
    visibility: hidden;
  }

  .caoz {
    margin-top: 8px;
    display: flex;
  }

  .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 3%;
    transition: all 0.2s ease 0.5s;
  }

  .block1 {
    visibility: hidden;
  }

  .block1>div {
    display: none;
  }

  .all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 5px 20px;
    border-radius: 3px;
  }

  .demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
  }

  .name_box {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      cursor: pointer;
      display: none;
    }
  }

  .tag_box {
    display: flex;
    flex-wrap: wrap;

    span {
      margin: 5px;
    }
  }

  .name_box:hover>i {
    display: block;
  }

  /* /deep/.el-table__body-wrapper {
  margin-top: var(--body);
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 1px;
  background-color: #f00 !important;
}

/deep/.el-table__header-wrapper {
  position: fixed;
  top: var(--header);
  transition: all 1s ease 0.15s;
  z-index: 999;
} */

  .rowClassOne {
    background-color: #e7ecff;
  }

  .rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
  }

  .rowClassThree {
    background-color: #6a88f1;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_header {
    display: flex;
    justify-content: space-between;
    height: 90px;
    position: fixed;
    width: 90%;
    z-index: 111;
  }

  /* 需要根据媒体查询更改的样式 */
  .changing-box {
    position: absolute;
    top: 50px;
    right: 1.2%;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_center {
    min-width: 500px;
    display: flex;
    justify-content: end;
    margin-top: 10px;
    margin-right: 17px;
  }
  .span_box_one{
    position: absolute;
    z-index: 1;
    left:260px;
    top: 100px;
    font-size: 14px;
  }
  /deep/.el-table__body-wrapper {
    height: calc(100vh - 250px);
  }

  /deep/.flex-images {
    width: 83.5%;
  }

  .copy {
    margin-top: 30px;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed !important;
    top: 162px !important;
  }

  .img_box {
    width: 150px;
    height: 120px;
    /deep/.el-image__inner{
      object-fit: contain  ;
    }
  }

     /* 朝上排序样式 */
  /deep/.el-table .ascending .sort-caret.ascending{
    background-color: #f00 !important;
    background: url("../img/12.png" )no-repeat -4px -3px !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
  }
  /* 朝下排序样式 */
  /deep/.el-table .descending .sort-caret.descending{
    background: url("../img/22.png" )no-repeat -5px 2px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 25px;
  }
  /deep/.el-table .descending .sort-caret.descending{
    border-top-color: #fff;
  }
  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }
  /deep/.el-table__footer-wrapper .has-gutter{
    height: 45px !important;
  }
  @media screen and (min-width: 2561px) and (max-width: 3440px) {
    .copy{
      margin-top: 45px !important;
    }
  }
  @media screen and (min-width: 3441px) and (max-width: 3840px) {
    .copy{
      margin-top: 45px !important;
    }
  }




    .btn2 {
      display: flex;
      align-items: center;
      margin-top:0px;
      margin-left:3px;
    }

    .btn2 button {
      outline: none;
      border: 1px solid #d1d1d1;
      margin: 0 2px;
      /* 添加这一行 */
      width: 100px;
      height: 35px;
      cursor: pointer;
      font-size: 12px;
    }

    .btn2 button.active {
      border-bottom: none;
      outline: none;
      background-color: #fff;
    }

    /deep/.source_ID{
        text-indent: 20px !important;
    }


  /deep/.el-table th.el-table__cell{
    background: #F5F7FA !important;
    padding: 0 !important;
  }
  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 205px) !important;
    top: 35px !important;
  }
  /deep/.el-table__fixed {
    height: calc(100% - 12px) !important;
  }
  /deep/.el-table__fixed-footer-wrapper{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/modeList.vue